export const PAKET_META = {
  'CVFlow Starter': { tag: 'Einstieg',  tagStar: false, features: ['Für gezielte Bewerbungen','Analyse, CV, Anschreiben & Check','Dauerhaft bearbeitbar'] },
  'CVFlow Pro':     { tag: 'Bestseller',tagStar: true,  features: ['Unbegrenzte Nutzung des Agenten-Workflows','Für eine aktive Jobsuche','Alle Pläne inklusiv'] },
  'CVFlow Expert':  { tag: 'Intensiv',  tagStar: false, features: ['Für intensives Bewerbungstempo','Viele Unternehmen & Profilvarianten','Dauerhafter Zugriff'] },
};

export const TONLAGEN = [
  { id: 'klassisch', label: 'Klassisch', desc: 'Professionell & sachlich' },
  { id: 'modern',    label: 'Modern',    desc: 'Zeitgemäß & direkt' },
  { id: 'kreativ',   label: 'Kreativ',   desc: 'Ausdrucksstark & persönlich' },
  { id: 'formell',   label: 'Formell',   desc: 'Streng & traditionell' },
];

export const THEMES = [
  { id: 'paper',  label: 'Paper',         subtitle: 'Warm & hell',       colors: ['#F5F0E8', '#1A3828', '#EDE6D6'] },
  { id: 'forest', label: 'Forest & Amber', subtitle: 'Dunkelgrün & Gold', colors: ['#0D2218', '#F5C842', '#122B1E'] },
  { id: 'mono',   label: 'Mono',          subtitle: 'Editorial & minimal', colors: ['#0A0A0A', '#FFFFFF', '#1A1A1A'] },
];
